import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import stripCategoryId from '@jetshop/core/components/Filters/utils/stripCategoryId';
import ErrorBoundary from '@jetshop/ui/ErrorBoundary/Generic';
import PassThrough from '@jetshop/ui/ErrorBoundary/PassThrough';
import { ListItem, StyledCheck } from '@jetshop/ui/Select/Components';
import { css } from 'emotion';
import * as React from 'react';
import styled from 'react-emotion';
const StyledListItem = styled(ListItem) `
  background: #f0f0f0;
  border-color: white;
  font-size: 0.875rem;
`;
const Quantity = styled('span') `
  font-size: ${({ theme }) => theme.fontSizes[1]};
  margin-left: 4px;
  color: #878787;
`;
const ListFilterList = ({ filters, id: inputId }) => {
    const id = stripCategoryId(inputId);
    return (React.createElement(ErrorBoundary, { component: PassThrough },
        React.createElement(FilterContext.Consumer, null, ({ applyListFilter, activeFilters: { listFilters }, clearListFilter }) => {
            // The id here denotes the list filter type, i.e. color, print, size.
            // Check if there are any selected filters in the given filter type
            const selectedFilter = listFilters.find(i => i.id === id || i.id === inputId);
            // Map the currently selected items to an array compatible with `applyListFilter`
            // We want to combine the currently selected item(s) with the item in the onClick
            // event below.
            const selectedItems = (selectedFilter &&
                selectedFilter.values.map(f => ({ value: f }))) ||
                [];
            return filters.map(item => {
                // Is the item we are currently mapping over selected?
                // We use this to display a checkmark
                const isSelected = selectedFilter && selectedFilter.values.includes(item.value);
                return (React.createElement(StyledListItem, { disabled: item.resultCount === 0, onClick: () => isSelected
                        ? // If this is already selected, de-select it
                            clearListFilter(id, item.value)
                        : // Otherwise, apply it along with the already-selected items
                            applyListFilter(id, [...selectedItems, item]), key: item.value },
                    React.createElement("div", null,
                        item.text || item.value,
                        item.resultCount !== null ? (React.createElement(Quantity, null,
                            " (",
                            item.resultCount,
                            ")")) : null),
                    isSelected && (React.createElement(StyledCheck, { className: css `
                      margin-right: 0;
                    ` }))));
            });
        })));
};
export default ListFilterList;
//# sourceMappingURL=ListFilterList.js.map